module.exports = new __parcel__URL__("recovery-link.ea6b9eb4.png").toString();